import React, { useEffect, useRef } from "react";

export const useFetch = (axios) => {
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    let cancelled = false;
    
    const getFetch = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios;
        // Проверяем, что запрос не был отменен
        if (!cancelled && isMountedRef.current) {
          setData(response.data);
        }
      } catch (error) {
        if (!cancelled && isMountedRef.current) {
          setError(error);
        }
      } finally {
        if (!cancelled && isMountedRef.current) {
          setLoading(false);
        }
      }
    };
    
    getFetch();

    return () => {
      cancelled = true;
      isMountedRef.current = false;
    };
  }, [axios]);
  
  return {
    data,
    error,
    loading,
  };
};
